import { createContext, useContext } from 'react';

import { QuestionsReporData } from '../types';

export const ReportContextContext = createContext({} as QuestionsReporData);

export function ReportContext({
  children,
  value,
}: {
  children: React.ReactNode;
  value: QuestionsReporData;
}) {
  return (
    <ReportContextContext.Provider value={value}>
      {children}
    </ReportContextContext.Provider>
  );
}

export function useReport() {
  const context = useContext(ReportContextContext);

  if (!context) {
    throw new Error('useReport must be used within a ReportContext');
  }

  return context;
}
